export default __webpack_public_path__ + "static/media/not-filled.0d65d203.svg";